import SDK from '../../../../SDK';
import Translate from './Translate';
import React, { Fragment, useEffect, useState } from 'react';
import Store from '../../../../../Store';
import { useSelector, connect } from 'react-redux';
import { showModal } from '../../../../../Actions/PopUp';
import { callIntermediateScreen } from '../../../../../Actions/CallAction';
import { MeetingLinkIcon } from '../../../../../assets/images';
import { CALL_STATUS_CONNECTED, CALL_STATUS_RECONNECT } from '../../../../../Helpers/Call/Constant';
import {
    blockOfflineAction,
    convertTextToURL,
    getFormattedText,
    getSiteDomain,
    handleScheduledTimeFormat,
    isCallLink,
} from '../../../../../Helpers/Utility';
import { handleMentionedUser } from '../../../../../Helpers/Chat/User';
import PropTypes from 'prop-types';

const HtmlToReactParser = require('html-to-react').Parser;
const htmlToReactParser = new HtmlToReactParser();

const MeetComponent = (props = {}) => {
    const { messageObject = {}, isSender = false, pageType, vCardData = {} } = props;
    const { msgBody = {} } = messageObject;
    const { data = {} } = vCardData;
    const messageLink = convertTextToURL(msgBody?.meet?.link);
    const { data: conferenceData = {} } = useSelector(state => state.showConfrenceData || {});
    const { data: callData = {} } = useSelector(state => state.callIntermediateScreen || {});
    const [callLinkMessageBody, setCallLinkMessageBody] = useState({
        prevMeetText: null,
        meetLink: null,
        endMeetText: null,
        scheduledon: null,
        meetingTitle: null,
    });
    const isTranslated = () =>
        !isSender &&
        pageType === 'conversation' &&
        msgBody?.translatedMessage &&
        Object.keys(msgBody.translatedMessage).length;

    const renderMessageBody = () => {
        const mentionedUsers = msgBody?.mentionedUsersIds ? msgBody.mentionedUsersIds : [];
        const formattedText = htmlToReactParser.parse(
            handleMentionedUser({
                text: getFormattedText(messageLink),
                mentionedUsersIds: mentionedUsers,
                mentionedMe: !isSender && data.userId,
                mentionedClass: null,
                chatType: messageObject.chatType,
            }),
        );
        const result = msgBody ? formattedText : null;
        return result;
    };

    const subscribeToCall = async meetLink => {
        if (blockOfflineAction()) return '';
        const callLink = meetLink?.split(`${getSiteDomain()}/`)[1];
        if (
            callData &&
            (conferenceData.callStatusText === CALL_STATUS_CONNECTED ||
                conferenceData.callStatusText === CALL_STATUS_RECONNECT)
        ) {
            const roomLink = await SDK.getCallLink();
            if (meetLink.includes(roomLink.data)) {
                props.handleShowCallScreen();
            } else {
                Store.dispatch(
                    showModal({
                        open: true,
                        modelType: 'CallConfirm',
                        newCallLink: callLink,
                    }),
                );
            }
        } else {
            Store.dispatch(callIntermediateScreen({ show: true, link: callLink }));
        }
    };

    useEffect(() => {
        const urlRegex = /https?:\/\/\S+/g;
        const ArrayOfLinkSplit = (msgBody?.meet?.link && msgBody.meet.link?.split(urlRegex)) || [];
        const meetLinkUrl = (msgBody?.meet?.link && msgBody.meet.link?.match(urlRegex)) || [];
        const scheduledon = handleScheduledTimeFormat(msgBody?.meet?.scheduledDateTime);
        const meetTitle = msgBody?.meet?.title;
        setCallLinkMessageBody({
            prevMeetText: ArrayOfLinkSplit[0],
            meetLink: meetLinkUrl[0],
            endMeetText: ArrayOfLinkSplit[1],
            scheduledon: scheduledon,
            meetingTitle: meetTitle,
        });
    }, []);

    return (
        <div className="meetinglink">
            <Fragment>
                {callLinkMessageBody.meetLink != null && isCallLink(callLinkMessageBody.meetLink) ? (
                    <div className="message_meeting_link">
                        <button
                            type="button"
                            className="meetingL_link_share"
                            onClick={() => subscribeToCall(callLinkMessageBody.meetLink)}
                        >
                            <div className="meeting_link_detail">
                                <div className="meetinglink_header">
                                    <div>
                                        <span className="meeting_ink">{callLinkMessageBody.meetLink}</span>
                                    </div>
                                </div>
                                {/* <div className='meetinglink_user_message'>You've been invited to join the EN Connect meeting Follow the link below to join the call.</div> */}

                                <div className="meeting_bg">
                                    {msgBody?.meet?.scheduledDateTime != 0 && (
                                        <div className="meeting_center_description">
                                            <div className="meeting_center_left">
                                                <div className="scheduled_label">
                                                    {callLinkMessageBody?.meetingTitle}
                                                </div>
                                                <div className="scheduled_message">
                                                    {callLinkMessageBody?.scheduledon}
                                                </div>
                                            </div>
                                            <div>
                                                <img
                                                    className="mirrorfly_meeting_logo"
                                                    src={MeetingLinkIcon}
                                                    alt="EN Connect Video Call"
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <span className="textmessages">{callLinkMessageBody.prevMeetText}</span>

                                    <span className="textmessages">{callLinkMessageBody.endMeetText}</span>
                                    {/* <div className='harizontal-line'></div> */}
                                    <div className="meeting_desc">
                                        <span className="call_details">Join Video Call</span>
                                    </div>
                                </div>
                            </div>
                            {/* // :(
            //       <div className='meeting_center_description'>
            //         <span>EN Connect video Call link</span>
            //         <span className="call_icon">
            //           <IconMeetingVideo />
            //         </span>
            //       </div>
            //     )} */}

                            {/* <div className="meeting_desc">
              <img className="mirrorfly_meeting_logo" src={ImgFavicon} alt="EN Connect Video Call" />
              <span className="call_details">Join video meeting</span>
              </div> */}
                            {!!isTranslated() && <Translate tMessage={msgBody?.translatedMessage} />}
                        </button>
                    </div>
                ) : (
                    <div className="message-text">
                        <span>{renderMessageBody()}</span>
                        {!!isTranslated() && <Translate tMessage={msgBody?.translatedMessage} />}
                    </div>
                )}
            </Fragment>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        vCardData: state.vCardData,
        groupsMemberListData: state.groupsMemberListData,
    };
};
export default connect(mapStateToProps, null)(MeetComponent);

MeetComponent.propTypes = {
    messageObject: PropTypes.shape({
        msgBody: PropTypes.shape({
            meet: PropTypes.shape({
                link: PropTypes.string,
                scheduledDateTime: PropTypes.number,
            }),
            translatedMessage: PropTypes.object,
        }),
        chatType: PropTypes.string,
    }),
    isSender: PropTypes.bool,
    pageType: PropTypes.string,
    handleShowCallScreen: PropTypes.func,
    vCardData: PropTypes.object,
};
